import React from "react";

interface CodeBlockProps {
  text?: string;
  lang?: string;
  children?: React.ReactNode;
  plainText?: boolean; // Skip all color formatting
}

const CodeBlock: React.FC<CodeBlockProps> = ({ text, children, plainText = false }) => {
  const content = text || (typeof children === "string" ? children : "");
  
  const processText = () => {
    // If plainText is true, return content without any formatting
    if (plainText) {
      return { __html: content };
    }
    
    // Create a working copy of the text
    let result = content;
    
    // Apply highlighting via styled spans using simple substitutions
    result = result
      // Highlight functions (sum:, avg:, min:, max:, count:)
      .replace(/(sum|avg|min|max|count):/g, '<span style="color: #3b82f6; font-weight: 600;">$1:</span>')
      
      // Highlight operators (by, and, or, AND, OR)
      .replace(/\b(by|and|or|AND|OR)\b/g, '<span style="color: #a855f7;">$1</span>')
      
      // Highlight metrics (container.memory.working_set, etc.)
      .replace(/\b(\w+\.\w+\.\w+)\b/g, '<span style="color: #06b6d4;">$1</span>')
      
      // Highlight math operators
      .replace(/\s([*/+-])\s/g, ' <span style="color: #ec4899;">$1</span> ');
    
    return { __html: result };
  };
  
  return (
    <pre className="font-mono text-sm p-3 rounded-md overflow-x-auto whitespace-pre-wrap break-words bg-card border border-border">
      <code dangerouslySetInnerHTML={processText()} />
    </pre>
  );
};

export default CodeBlock;
